// 店舗内求人選択(単一選択)。 選択した求人の応募フォーム(/entry/:id/y)へ直接遷移する
const FORM_SELECTOR = '#js-shop-entry-form'

export const shopEntrySelect = () => {
  const form = document.querySelector<HTMLFormElement>(FORM_SELECTOR)
  if (form == null) return

  form.addEventListener('submit', (event) => {
    const radios = Array.from(form.querySelectorAll<HTMLInputElement>('input[type="radio"]'))
    const checked = radios.find((radio) => radio.checked)

    // 上から何番目の求人を選択して応募に進んだか(1始まり)をevent_valueで送る
    if (checked != null) {
      window.gtag?.('event', 'click', {
        event_label: 'shop-entry-select',
        event_value: String(radios.indexOf(checked) + 1)
      })
    }

    const target = checked?.dataset.target
    if (target == null) return

    event.preventDefault()
    window.location.href = target
  })
}
